import React from "react";
import profileImage from "../assets/img/avatars/profileImage.jpg";
import { handleToggleContractors } from "actions/actions";
import { toast } from "react-toastify";
import BlockToggle from "views/admin/moqawelon/components/BlockToggle";
import DeleteUser from "views/admin/users/components/DeleteUser";
import ExtendTrial from "views/admin/users/components/ExtendTrial";
import "../styles/moqawelonColumn.css";
import ImageModal from "../components/imageModel/imageMode.jsx";
import { useState } from "react";
import ContractInfo from "../components/ContractInfo.jsx";

const BASE_URL = process.env.REACT_APP_ENDPOINT;

const MoqawelonColumn = (refetch) => [
  {
    Header: "تحديد",
    id: "checkbox",
  },
  {
    Header: "الاسم",
    accessor: "name",
    Cell: ({ row }) => {
      const [isModalOpen, setIsModalOpen] = useState(false);

      const handleImageClick = () => {
        setIsModalOpen(true);
      };

      const handleCloseModal = () => {
        setIsModalOpen(false);
      };

      return (
        <div className="flex min-w-[140px] items-center gap-3">
          <img
            src={
              row.original.photo
                ? `${BASE_URL}/${row.original?.photo}`
                : profileImage
            }
            alt={row.values.id}
            className="h-12 w-12 cursor-pointer rounded-lg object-cover"
            crossOrigin="anonymous"
            onClick={handleImageClick}
          />
          {isModalOpen && (
            <ImageModal
              src={
                row.original.photo
                  ? `${BASE_URL}/${row.original?.photo}`
                  : profileImage
              }
              onClose={handleCloseModal}
            />
          )}
          <span className="font-medium">{row.original.name || "—"}</span>
        </div>
      );
    },
  },
  {
    Header: "رقم الهاتف",
    accessor: "phoneNumber",
    Cell: ({ row }) => {
      return (
        <a
          className="text-blue-500 hover:underline"
          href={`tel:${row.original.phoneNumber}`}
        >
          {row.original.phoneNumber}
        </a>
      );
    },
  },
  {
    Header: "العقد",
    accessor: "contractorInfo",
    Cell: ({ row }) => {
      return <ContractInfo contractor={row.values.contractorInfo} />;
    },
  },
  {
    Header: "الحالة",
    accessor: "active",
    Cell: ({ row }) => {
      return (
        <span
          className={`rounded-full px-2 py-1 text-xs ${
            row.values.active
              ? "bg-green-500 text-white"
              : "bg-red-500 text-white"
          }`}
        >
          {row.values.active ? "مفعل" : "غير مفعل"}
        </span>
      );
    },
  },
  {
    Header: "إجراء",
    accessor: "id",
    Cell: ({ row }) => {
      return (
        <div className="flex flex-col items-start gap-2">
          {row.original.active ? (
            <BlockToggle
              id={row.original.id}
              refetch={refetch}
              name={row.original.name}
            />
          ) : (
            <button
              className="rounded-full bg-green-500 px-6 py-1 text-white transition-all hover:bg-green-600 disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-400"
              onClick={() =>
                handleToggleContractors(row.original.id, "active").then(
                  (res) => {
                    if (res.error) {
                      toast.error(res.error);
                    } else {
                      toast.success(res.success);
                      refetch();
                    }
                  }
                )
              }
            >
              تفعيل
            </button>
          )}
          {row.original.role === "user" && (
            <ExtendTrial
              id={row.original.id}
              userId={row.original.id}
              refetch={refetch}
            />
          )}
          <DeleteUser id={row.original.id} refetch={refetch} />
        </div>
      );
    },
  },
];

export default MoqawelonColumn;
